/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Next_JsInputs */

const en_svchip_next_js = /** @type {(inputs: Svchip_Next_JsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next.js`)
};

const ar_svchip_next_js = /** @type {(inputs: Svchip_Next_JsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next.js`)
};

const bn_svchip_next_js = /** @type {(inputs: Svchip_Next_JsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next.js`)
};

const de_svchip_next_js = /** @type {(inputs: Svchip_Next_JsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next.js`)
};

const es_svchip_next_js = /** @type {(inputs: Svchip_Next_JsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente.js`)
};

const fr_svchip_next_js = /** @type {(inputs: Svchip_Next_JsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivant.js`)
};

const pt_svchip_next_js = /** @type {(inputs: Svchip_Next_JsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo.js`)
};

const zh_svchip_next_js = /** @type {(inputs: Svchip_Next_JsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next.js`)
};

const tr_svchip_next_js = /** @type {(inputs: Svchip_Next_JsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonraki.js`)
};

const ru_svchip_next_js = /** @type {(inputs: Svchip_Next_JsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next.js`)
};

const pl_svchip_next_js = /** @type {(inputs: Svchip_Next_JsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następny.js`)
};

/**
* | output |
* | --- |
* | "Next.js" |
*
* @param {Svchip_Next_JsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_next_js = /** @type {((inputs?: Svchip_Next_JsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Next_JsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_next_js(inputs)
	if (locale === "bn") return bn_svchip_next_js(inputs)
	if (locale === "de") return de_svchip_next_js(inputs)
	if (locale === "es") return es_svchip_next_js(inputs)
	if (locale === "fr") return fr_svchip_next_js(inputs)
	if (locale === "pt") return pt_svchip_next_js(inputs)
	if (locale === "zh") return zh_svchip_next_js(inputs)
	if (locale === "tr") return tr_svchip_next_js(inputs)
	if (locale === "ru") return ru_svchip_next_js(inputs)
	if (locale === "pl") return pl_svchip_next_js(inputs)
	return en_svchip_next_js(inputs)
});